import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const r2b_referral_7: R2BReferralBrandEntity = {
  token: "r2b_referral_7",
  type: "r2bReferralBrand",
  name: "Gourmet Eats",
  email: "emily.jones@example.com",
  website: "gourmet-eats.com",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
